"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _Y34TXRAIcjs = require('../__chunks/Y34TXRAI.cjs');


var _DEKAT4J4cjs = require('../__chunks/DEKAT4J4.cjs');
require('../__chunks/AVNURAH2.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/tab/tab-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function TabProvider(props = {}) {
  const store = _Y34TXRAIcjs.useTabStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _DEKAT4J4cjs.TabContextProvider, { value: store, children: props.children });
}


exports.TabProvider = TabProvider;
